import { getDisplayName } from '@/utilities/UserUtilities'

import messages from './messages'

export default ({ intl }: any) => [
  {
    property: 'name.familyName',
    header: {
      label: intl.formatMessage(messages.name),
      sortable: true
    },
    cell: {
      formatters: [(id: any, { rowData }: any) => <span className="keyvalues__label">{getDisplayName(rowData)}</span>]
    }
  },
  {
    property: 'email',
    header: {
      label: intl.formatMessage(messages.email)
    },
    cell: {
      formatters: [(id: any, { rowData }: any) => <span className="sub-text">{rowData.email}</span>]
    }
  }
]
